import { cn } from '../../lib/utils';

/** One piece of kit as a pill: our own gear filled, a hire outlined. As in the PDF. */
export default function GearTag({ name, quantity, hire }) {
  return (
    <li
      title={hire ? 'Hired in' : undefined}
      className={cn(
        // Every pill has a 1px border, invisible on our own gear, so its text is
        // always the same 11px in from the edge (the shot's gear row relies on it)
        'inline-flex items-center gap-1 h-7 px-2.5 rounded-pill border text-xs font-medium',
        hire ? 'border-line-strong text-foreground' : 'border-transparent bg-mist text-foreground',
      )}
    >
      {name}
      {quantity > 1 && <span className="text-muted-foreground">×{quantity}</span>}
      {hire && <span className="sr-only"> (hire)</span>}
    </li>
  );
}
